import {cloneDeep} from 'lodash';
import {ActionTypes} from '../actions';
import {Dealer} from '../../common/actionTypes';
import createReducer from '../../common/util/createReducer';

const sections = [{
  'id': 'title_section',
  'position': 1,
  'fields': [{
    'id': '1',
    'position': 1,
    'label': 'Tema',
    'type': 'text',
    'options': [{
      'id': 'title',
      'position': 1,
      'isRequired': true,
      'type': 'text',
      'config': {
        'maxLength': 40,
      },
    }],
  }, {
    'id': 'cause_of_the_problem',
    'position': 2,
    'isRequired': true,
    'label': 'Detalle',
    'type': 'textArea',
    'config': {
      'maxLength': 1000,
    },
  }],
}];

const INITIAL_STATE = {
  'saving': false,
  'saved': false,
  'loading': false,
  'id': '',
  'formNumber': '',
  'type': '',
  'status': '',
  sections,
  'answers': {},
  'chassisInfo': {},
  'generalInfo': {},
  'attachments': [],
};

const updateGeneralInformation = (generalInfo, {field, value}) => {
  const newInfo = {...generalInfo};
  newInfo[field] = value.toUpperCase();
  if (field === 'isRepared' && value === 'NO') {
    newInfo.repairOfDate = '';
  }
  return newInfo;
};

const updateAnswers = (answers, {fieldType, fieldId, optionId, value, isOther, isMultipleSelection}) => {
  const newAnswers = cloneDeep(answers);

  switch (fieldType) {
    default:
    case 'textArea':
      newAnswers[fieldId] = value;
      return newAnswers;
    case 'text':
    case 'number':
      if (isOther) {
        newAnswers[fieldId][`${optionId}-other`] = value;
        return newAnswers;
      }
      newAnswers[optionId] = value;
      return newAnswers;
    case 'checkbox':
      if (!isMultipleSelection) {
        newAnswers[fieldId] = {};
        newAnswers[fieldId][optionId] = value;
        return newAnswers;
      }

      if (!newAnswers.hasOwnProperty(fieldId)) {
        newAnswers[fieldId] = {};
      }
      if (value) {
        newAnswers[fieldId][optionId] = value;
        return newAnswers;
      }

      delete newAnswers[fieldId][optionId];
      if (isOther) {
        delete newAnswers[fieldId][`${optionId}-other`];
      }
      return newAnswers;
  }
};

const urltoFile = (url, filename, mimeType) => {
  return fetch(url)
    .then((res) => {
      return res.arrayBuffer();
    })
    .then((buf) => {
      return new File([buf], filename, {'type': mimeType});
    });
};

const convertBase64ToFiles = (attachments) => {
  const files = [];
  attachments.forEach((item) => {
    const base64 = `data:image/jpeg;base64, ${item.file}`;
    urltoFile(base64, item.name, item.mimetype).then((file) => {
      files.push(file);
    });
  });
  return files;
};

export const templateSKR = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_FORM]: (state, action) => ({
      ...state,
      'saving': false,
      'saved': false,
      'loading': false,
      'id': '',
      'formNumber': '',
      'type': '',
      'status': '',
      'answers': {},
      'chassisInfo': {},
      'generalInfo': {},
      'attachments': [],
    }),
    [Dealer.FETCHED_DEALER]: (state, action) => {
      const dealerInfo = action.response.data;
      return {
        ...state,
        'generalInfo': {
          ...state.generalInfo,
          'dealerId': dealerInfo.identification,
          'dealerName': dealerInfo.name,
        },
      };
    },
    [ActionTypes.FETCHING_CHASSIS_INFO]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_CHASSIS_INFO]: (state, action) => {
      const chassisData = action.response.data;
      return {
        ...state,
        'loading': false,
        'chassisInfo': chassisData,
        'generalInfo': {
          ...state.generalInfo,
          'modelName': chassisData.modelName,
        },
      };
    },
    [ActionTypes.FETCHED_CHASSIS_INFO_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'chassisInfo': {},
    }),
    [ActionTypes.SET_GENERAL_INFO]: (state, action) => ({
      ...state,
      'generalInfo': updateGeneralInformation(state.generalInfo, action.payload),
    }),
    [ActionTypes.SET_VALUE_IN_FORM]: (state, action) => ({
      ...state,
      'answers': updateAnswers(state.answers, action.payload),
    }),
    [ActionTypes.SET_FILES]: (state, action) => ({
      ...state,
      'attachments': action.payload,
    }),
    [ActionTypes.SAVING_FORM]: (state) => ({
      ...state,
      'saving': true,
    }),
    [ActionTypes.SAVED_FORM]: (state, action) => {
      const formResponse = action.response.data;
      return {
        ...state,
        'saving': false,
        'saved': true,
        'loading': false,
        'id': formResponse.answerId.$oid,
        'formNumber': '',
        'type': '',
        'status': '',
        'answers': {},
        'chassisInfo': {},
        'generalInfo': {},
        'attachments': [],
      };
    },
    [ActionTypes.SAVED_FORM_FAILED]: (state) => ({
      ...state,
      'saving': false,
    }),

    [ActionTypes.FETCHING_FORM_RESPONSE]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_FORM_RESPONSE]: (state, action) => {
      const formResponse = action.response.data;
      const type = action.payload;
      return {
        ...state,
        'loading': false,
        'id': formResponse._id.$oid,
        'formNumber': formResponse.formNumber,
        'type': formResponse.type,
        'status': formResponse.status,
        'generalInfo': formResponse.generalInfo,
        'answers': formResponse.answers,
        'attachments': type === 'ver' ? formResponse.attachments : convertBase64ToFiles(formResponse.attachments),
      };
    },
    [ActionTypes.FETCHED_FORM_RESPONSE_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'id': '',
      'formNumber': '',
      'name': '',
      'type': '',
      'status': '',
      'generalInfo': '',
      'answers': {},
      'attachments': [],
    }),
    [ActionTypes.CHANGE_SAVED_VALUE]: (state, action) => ({
      ...state,
      'saved': false,
    }),
  })(state, action);
};
